export const PURCHASE_ORDER_PAYMENT_TERM_OTHER = 'OTH';
